import React, { Component } from 'react'
import './Nav.css'

export default class Nav extends Component {
    render() {
        return (
            <div id="nav">
                Memer
            </div>
        )
    }
}
